import classNames from 'classnames';
import Head from 'next/head';
import React, {PropsWithChildren, ReactElement} from 'react';

import URLS from '../../../../urls';
import Col from '../../../common/Col';
import Row from '../../../common/Row';
import {useBreakpoint} from '../../../common/util/useBreakpoint';
import {GeneralCalculator} from '../../../strapi/generated/components';
import {ApiResourceResource} from '../../../strapi/generated/contentTypes';
import {ProcessedValues} from '../../../strapi/types';
import RelatedResources from '../RelatedResources';
import ResourceHeader from '../ResourceHeader';
import RichText from '../RichText';

type Props = {
  calculator: ProcessedValues<GeneralCalculator>;
};

const CalculatorWrapper = ({calculator, children}: PropsWithChildren<Props>): ReactElement => {
  const {isTablet} = useBreakpoint('tablet');

  // ProcessedValues doesn't properly infer oneToMany relations, so we need to cast it to the correct type
  const resources = calculator.resources as any as ProcessedValues<ApiResourceResource>[] | undefined;

  return (
    <>
      <Head>
        <title>{calculator.title} - Envirocrops</title>
      </Head>
      <ResourceHeader
        sideBarWidth={'150'}
        backUrl={URLS.calculators.index}
        label={'Calculator'}
        title={calculator.title}
      />
      <Row className="grow">
        {!isTablet && <div className={classNames('flex-none w-[150px]')}>{/* spacer */}</div>}
        <Col className="w-full mx-auto max-w-limit px-sm py-lg gap-lg">
          <RichText className={'text-sm'} content={calculator.description} />
          {children}
          <RichText className={'text-sm'} content={calculator.conclusion} />
          {!!resources?.length && (
            <RelatedResources className={'w-full mt-md py-lg'} title={'Related resources'} resources={resources} />
          )}
        </Col>
      </Row>
    </>
  );
};

export default CalculatorWrapper;
